import { domain } from 'modules/data';

import { StepParticipantHoverProps } from './StepParticipantHover.types';

export const isReviewer = (
    participant: StepParticipantHoverProps['participant']
): participant is domain.RequestReviewer => {
    return 'id' in participant && Object.values(domain.RequestStepReviewerSource).includes(participant.source);
};
